<!-- eslint-disable-next-line  @angular-eslint/template/interactive-supports-focus-->
<div class="td-wb-mobile-flyout-menu-backdrop"
     (click)="onBackdropClicked()">
</div>
<ng-content select="td-wb-mobile-flyout-menu-nav" />
